import React from 'react';
import { ShieldCheck, Globe, Zap, BadgeDollarSign, FileCheck, Lock } from 'lucide-react';

const benefits = [
  { icon: ShieldCheck, title: "Prevent Brand Theft", desc: "Gain legal authority to stop counterfeiters, copycats, and unauthorized sellers from profiting off your brand." },
  { icon: Globe, title: "Nationwide Exclusivity", desc: "Your registered trademark is protected in every US state. Scale your business without worrying about territorial disputes." },
  { icon: Zap, title: "Faster Dispute Resolution", desc: "Federal registration gives you priority in legal proceedings, stronger remedies, and the ability to recover damages." },
  { icon: BadgeDollarSign, title: "Build Brand Equity", desc: "A trademark appreciates over time. It strengthens your position in licensing, franchising, and acquisition deals." },
  { icon: FileCheck, title: "Amazon Seller Tools", desc: "Brand Registry unlocks A+ Content, Sponsored Brands, automated IP protection, and enhanced listing control." },
  { icon: Lock, title: "Permanent Protection", desc: "Once registered, renew your trademark indefinitely. Your brand name, logo, and slogan stay legally protected for life." }
];

const BenefitsSection = () => {
  return (
    <section id="benefits" data-testid="benefits-section" className="py-24 md:py-32 bg-[#F8F9FA]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="max-w-2xl mb-16">
          <p className="text-sm uppercase tracking-[0.2em] font-medium text-[#002FA7] mb-4">Key Benefits</p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.2] text-[#0A0F1C] mb-5">
            What Trademark Registration Gets You
          </h2>
          <p className="text-base text-[#4B5563] leading-relaxed">
            Trademark registration is one of the smartest investments you can make for your business. Here's exactly what you gain.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {benefits.map((b, i) => (
            <div
              key={i}
              data-testid={`benefit-item-${i}`}
              className="group bg-white border border-[#E5E7EB] p-7 transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_20px_40px_rgba(10,15,28,0.06)] hover:border-[#002FA7]/30"
            >
              <div className="w-11 h-11 border border-[#E5E7EB] group-hover:border-[#002FA7]/30 group-hover:bg-[#002FA7]/5 flex items-center justify-center mb-5 transition-all duration-500">
                <b.icon className="w-5 h-5 text-[#002FA7]" />
              </div>
              <h3 className="text-lg font-bold text-[#0A0F1C] mb-2">{b.title}</h3>
              <p className="text-sm text-[#4B5563] leading-relaxed">{b.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
